import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import classNames from "classnames/bind"

import { removeContactModal } from "actions/visibility";
import { sendContactFormData } from 'actions/contact'
import { Modal } from 'components/shared/Modals/Modal/Modal';
import TextField from 'components/shared/formElements/textField/TextField'
import TextArea from 'components/shared/formElements/textArea/TextArea'
import styles from './contact-modal.scss';

const cx = classNames.bind(styles)

export class ContactModal extends Component {

    state = {
        name: {
            value: '',
            validationIcon: ''
        },
        email: {
            value: '',
            validationIcon: ''
        },
        phone: {
            value: '',
        },
        message: {
            value: '',
            validationIcon: ''
        },
        errors: {
            displayNameError: false,
            displayEmailError: null,
            displayMessageError: null
        }
    }

    handleRemoveModal = () => {
        this.props.removeContactModal();
    };

    handleNameInput = (e) => {
        e.preventDefault();

        this.setState({
            name: {
                ...this.state.name,
                value: e.target.value
            },
            errors: {
                ...this.state.errors,
                displayNameError: !this.validateName(e.target.value)
            }
        });
    };

    handleEmailInput = (e) => {
        e.preventDefault();

        this.setState({
            email: {
                ...this.state.email,
                value: e.target.value
            },
            errors: {
                ...this.state.errors,
                displayEmailError: !this.validateEmail(e.target.value)
            }
        });
    }

    handlePhoneInput = (e) => {
        e.preventDefault()

        this.setState({
            phone: {
                ...this.state.phone,
                value: e.target.value
            }
        })
    };

    handleMessage = (e) => {
        e.preventDefault()

        this.setState( {
            message: {
                ...this.state.message,
                value: e.target.value
            },
            errors: {
                ...this.state.errors,
                displayMessageError: !this.validateMessage(e.target.value)
            }
        })
    }

    checkToEnableButton = () => {
        let enableButton = true;

        if (this.validateName() === false) {
            enableButton = false;
        }

        if (this.validateEmail() === false) {
            enableButton = false;
        }

        if (this.validateMessage() === false) {
            enableButton = false;
        }

        return enableButton
    };

    validateName = (text) => {
        let validName = true

        const value = text !== undefined ? text.trim() : this.state.name.value.trim()

        // Check this is not blank
        if (value === '') {
            validName =  false;
        }

        return validName
    };

    validateEmail = (text) => {
        let validEmail = true

        const value = text !== undefined ? text.trim() : this.state.email.value.trim()

        if (value === '') {
            validEmail = false
        }

        // Check if the name is Alphabetical
        if (!/^\S+@\S+$/i.test(value)) {
            validEmail = false
        }

        return validEmail
    }

    validateMessage = (text) => {
        let validMessage = true

        const value = text !== undefined ? text.trim() : this.state.message.value.trim()

        if (value === '') {
            validMessage = false
        }

        return validMessage
    }

    handleSubmit = (e) => {
        e.preventDefault();

        const { name, email, phone, message } = this.state

        let data = {
            name: name.value,
            email: email.value,
            phone: phone.value,
            message: message.value
        }

        this.props.sendContactFormData(data)
    }

    render() {
        const { name, email, phone, message, errors } = this.state

        return (
            <Fragment>
                {this.props.displayContactModal &&
                    <Modal handleRemoveModal={() => {}}>
                        <div id="contact-modal-wrapper">
                            <div className={cx("modal-header")}>
                                <span className={cx("icon-x")} title="Click to close the Contact Form."
                                      onClick={this.handleRemoveModal}></span>
                                <h1>Contact Form</h1>
                            </div>
                            <div className={cx("modal-body")}>
                                <p>If you are interested in discussing a potential position in a company (full-time only),
                                    fill out this form and I will get back to you.</p>

                                <form name="contactForm">
                                    <TextField
                                        props={{
                                            name: 'name',
                                            value: name.value,
                                            id: 'name',
                                            type: 'text',
                                            isRequired: true,
                                            hasError: errors.displayNameError,
                                            requiredText: 'Please enter a valid name',
                                            handleOnChange: this.handleNameInput,
                                            placeholder: 'Enter your name',
                                            label: 'Name'
                                        }}
                                    />

                                    <TextField
                                        props={{
                                            name: 'email',
                                            value: email.value,
                                            id: 'email',
                                            type: 'text',
                                            isRequired: true,
                                            hasError: errors.displayEmailError,
                                            requiredText: 'Please enter a valid email',
                                            handleOnChange: this.handleEmailInput,
                                            placeholder: 'Enter your email',
                                            label: 'Email'
                                        }}
                                    />

                                    <TextField
                                        props={{
                                            name: 'phone',
                                            value: phone.value,
                                            id: 'phone',
                                            type: 'phone',
                                            isRequired: false,
                                            handleOnChange: this.handlePhoneInput,
                                            placeholder: 'Enter your phone number',
                                            label: 'Phone'
                                        }}
                                    />

                                    <TextArea
                                        props={{
                                            name: 'Message',
                                            value: message.value,
                                            id: 'message',
                                            isRequired: true,
                                            hasError: errors.displayMessageError,
                                            requiredText: 'Please enter a valid message',
                                            handleOnChange: this.handleMessage,
                                            placeholder: 'Enter your message',
                                            label: 'Message'
                                        }}
                                    />
                                </form>
                            </div>
                            <div className={cx("modal-footer")}>
                                <div className={cx("button-wrapper")}>
                                    <button
                                        className={cx("cancel-button")}
                                        title="Click to cancel the Contact Form."
                                        onClick={this.handleRemoveModal}
                                    >Cancel
                                    </button>
                                    <button
                                        className={cx("submit-button", {
                                            "disabled": !this.checkToEnableButton()
                                        })}
                                        onClick={this.handleSubmit}
                                        disabled={!this.checkToEnableButton()}
                                    >Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Modal>
                }
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    displayContactModal: state.visibility.displayContactModal
})

const mapDispatchToProps = (dispatch) => ({
   removeContactModal: () => dispatch(removeContactModal()),
   sendContactFormData: (data) => dispatch(sendContactFormData(data))
});

export default connect(mapStateToProps, mapDispatchToProps) (ContactModal)